/* eslint-disable import/prefer-default-export */
import omit from 'lodash/omit'

export const prepareFeesToBulkEdit = <Input, Output>(
    items: Input[] = [],
): Output[] => {
    return items.map((i) => {
        return omit(i, [
            'feeName',
            'feeChargability',
            'productType',
        ])
    })
}
